import { render, staticRenderFns } from "./MobilePreviewSms.vue?vue&type=template&id=50037187"
import script from "./MobilePreviewSms.vue?vue&type=script&lang=js"
export * from "./MobilePreviewSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports